import { Routes } from "@angular/router";

import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./user/login/login.component";
import { RegisterComponent } from "./user/register/register.component";
import { VerifyEmailComponent } from "./user/verify-email/verify-email.component";
import { PasswordForgottenComponent } from "./user/password-forgotten/password-forgotten.component";
import { ResetPasswordComponent } from "./user/reset-password/reset-password.component";
import { UserSettingsComponent } from "./user/user-settings/user-settings.component";
import { LoggedOnGuard } from "./guards/logged-on.guard";
import { AnnotateComponent } from "./annotate/annotate.component";
import { AboutComponent } from "./about/about.component";
import { CanEditOrAddGuard } from "./guards/can-edit-or-add.guard";

const routes: Routes = [
    {
        path: "home",
        component: HomeComponent,
    },
    {
        path: "login",
        component: LoginComponent,
    },
    {
        path: "register",
        component: RegisterComponent,
    },
    {
        path: "confirm-email/:key",
        component: VerifyEmailComponent,
    },
    {
        path: "password-forgotten",
        component: PasswordForgottenComponent,
    },
    {
        path: "reset-password/:uid/:token",
        component: ResetPasswordComponent,
    },
    {
        path: "user-settings",
        canActivate: [LoggedOnGuard],
        component: UserSettingsComponent,
    },
    {
        path: "annotate/:problemId/edit",
        canActivate: [LoggedOnGuard, CanEditOrAddGuard],
        component: AnnotateComponent,
    },
    {
        path: "annotate/:problemId",
        canActivate: [LoggedOnGuard, CanEditOrAddGuard],
        component: AnnotateComponent,
    },
    {
        path: "about",
        component: AboutComponent,
    },
    {
        path: "",
        redirectTo: "/home",
        pathMatch: "full",
    }
];

export { routes };
